import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
        <p className="text-secondary mb-8">页面未找到</p>
        <Link
          to="/"
          className="inline-block px-6 py-2 bg-surface hover:bg-surface/80 border border-border rounded-full text-primary font-medium transition-all"
        >
          返回首页
        </Link>
      </div>
    </div>
  )
}
